import {Component, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {
  MinimalApplicationConfiguration,
  MinimalApplicationGroup,
  MinimalDatabaseRetailConnection,
  MinimalTenant,
  PoiDbService
} from './poi-db.service';
import {ToastrService} from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

const DATABASE_CONNECTION_ERROR = 'failed to retrieve database connection details';

@Component({
    selector: 'app-poi-db',
    templateUrl: './poi-db.component.html',
    styleUrls: ['./poi-db.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class PoiDbComponent {

  public env: string;

  public tenants: MinimalTenant[] = [];
  public applicationGroups: MinimalApplicationGroup[] = [];

  public tenantIdDetails: number = null;
  public applicationConfigurationsForTenant: MinimalApplicationConfiguration[] = [];

  public minimalDatabaseConnection: MinimalDatabaseRetailConnection = null;

  constructor(
    private poiDbService: PoiDbService,
    private notificationService: ToastrService,
    private modalService: NgbModal,
  ) {

  }


  refreshEnv() {
    this.tenantIdDetails = null;
    this.displayTenantDetails(null, null);
    if (!this.env) {
      return;
    }
    this.tenants = [];
    this.poiDbService.getTenants(this.env).subscribe({
      next: tenants => this.tenants = tenants,
      error: err => {
        console.warn('failed to retrieve tenants', err);
        this.notificationService.error('failed to retrieve tenants');
      },
    });

    this.applicationGroups = [];
    this.poiDbService.getApplicationGroups(this.env).subscribe({
      next: applicationGroups => this.applicationGroups = applicationGroups,
      error: err => {
        console.warn('failed to retrieve applicationGroups', err);
        this.notificationService.error('failed to retrieve applicationGroups');
      },
    });
  }

  displayTenantDetails(id: number, tenantDetails: HTMLHeadingElement) {
    this.tenantIdDetails = id;
    this.applicationConfigurationsForTenant = [];
    if (!id) {
      return;
    }
    this.poiDbService.getApplicationConfigurations(this.env, id).subscribe({
      next: applicationConfigurations => {
        this.applicationConfigurationsForTenant = applicationConfigurations;
        tenantDetails.scrollIntoView(true);
      },
      error: err => {
        console.warn('failed to retrieve applicationConfigurations', err);
        this.notificationService.error('failed to retrieve applicationConfigurations');
      },
    });
  }

  getDb(applicationConfigration: MinimalApplicationConfiguration, content: TemplateRef<unknown>) {
    this.minimalDatabaseConnection = null;
    const tenant = this.tenants.find(candidate => candidate.id === this.tenantIdDetails);
    if (!tenant) {
      console.warn('no tenant');
      return;
    }
    this.poiDbService.getDatabase(this.env, tenant.tenantGroup.matchCode, applicationConfigration.id).subscribe({
      next: res => this.displayDbDetails(res, content),
      error: err => {
        console.warn(DATABASE_CONNECTION_ERROR, err);
        this.notificationService.error(DATABASE_CONNECTION_ERROR);
      },
    });
  }

  private displayDbDetails(res: MinimalDatabaseRetailConnection, content: TemplateRef<unknown>) {
    this.minimalDatabaseConnection = res;
    this.openModal(content);
  }

  private openModal(content: TemplateRef<unknown>) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }

  getDbCountry(applicationConfigration: MinimalApplicationConfiguration, content: TemplateRef<unknown>) {
    this.minimalDatabaseConnection = null;
    const tenant = this.tenants.find(candidate => candidate.id === this.tenantIdDetails);
    if (!tenant) {
      console.warn('no tenant');
      return;
    }
    this.poiDbService.getDatabaseCountry(this.env, tenant.country.iso3Code, applicationConfigration.id).subscribe({
      next: res => this.displayDbDetails(res, content),
      error: err => {
        console.warn(DATABASE_CONNECTION_ERROR, err);
        this.notificationService.error(DATABASE_CONNECTION_ERROR);
      },
    });
  }
}
